import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'modules/core'
import {
  openPaywall,
  selectRevenueCat,
  selectShowUpgrade,
  type PaywallSource,
} from '../slices/revenue-cat.slice'

export function useSubscriptionGate() {
  const dispatch = useAppDispatch()
  const showUpgrade = useAppSelector(selectShowUpgrade)
  const { isConfigured } = useAppSelector(selectRevenueCat)

  const requiresUpgrade = showUpgrade && isConfigured

  const gate = useCallback(
    (source: PaywallSource): boolean => {
      if (requiresUpgrade) {
        dispatch(openPaywall({ source }))
        return false
      }
      return true
    },
    [requiresUpgrade, dispatch]
  )

  return { gate }
}
